import React from "react";
import jwt_decode from "jwt-decode";
import { Form, Row, Modal, Button as ButtonBootstrap } from "react-bootstrap";
import { config } from "../../constants";
import apiClient from '../../utils/apiClient';

const url = config.url.URL;

export default class SelectProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CurrentProfile: null,
      Profiles: [],
      showModal: false,
    };
  }

  fetchProfiles() {

    apiClient.get(`${url}/UserMicroservice/UserProfile`)
      .then((response) => {
        const data = response.data;
        this.setState({
          Profiles: data,
        });

        if (this.state.Profiles.length == 1) {
          localStorage.setItem("multiProfiles", false);
          this.setCurrentProfile(
            this.state.Profiles[0].profileId,
            this.state.Profiles[0].profileName
          );
        } else {
          this.setState({ showModal: true });
          localStorage.setItem("multiProfiles", true);
        }
      });
  }

  setCurrentProfile(Profile, SelectedProfile) {
    if (Profile != null) {
      localStorage.setItem("ProfileId", Profile);

      if (localStorage.getItem("multiProfiles") == "true") {
        localStorage.setItem(
          "ProfileName",
          SelectedProfile.selectedOptions[0].text
        );
      } else {
        localStorage.setItem("ProfileName", SelectedProfile);
      }

      this.state.CurrentProfile = Profile;

      const decoded = jwt_decode(localStorage.getItem("token"));
      let userInfo = {
        username: decoded.UserId,
        profileId: Profile,
      };

      apiClient.post(`${url}/login/LoginUserWithProfile`, userInfo)
        .then((response) => {
          const { token } = response.data;
          localStorage.setItem("token", token);
          const newDecodedToken = jwt_decode(token);
          localStorage.setItem("RoleName", newDecodedToken.RoleName);
          const obj = JSON.parse(newDecodedToken.Prop);
          if (newDecodedToken.can_access_budget_list == "true" && obj.IdentityType == "Agency") {
            this.props.data.profileSelected("budget");
          } else if (newDecodedToken.can_create_reports == "true") {
            this.props.data.profileSelected("report");
          } else {
            this.props.data.profileSelected("admin");
          }
          this.state.showModal = false;
          this.setState({ showModal: false });
        });
    }
  }

  setShowModal() {}

  componentDidMount() {
    this.fetchProfiles();
  }

  render() {
    let l_Profiles = this.state.Profiles;
    let optionProfiles = l_Profiles.map((Profile) => (
      <option value={Profile.profileId}>{Profile.profileName}</option>
    ));

    return (
      <Modal show={this.state.showModal} size="sm" className="select-profile">
        <Modal.Header>
          <Modal.Title size="h1" className="font-15">
            <b>Select Profile</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className="line-h-30 font-15">
                You have access to several profiles.
                <br /> Please select the profile you wish to <br /> sign on with
                :
              </Form.Label>
              <Form.Control
                ref="optionProfiles"
                placeholder="Profiles"
                as="select"
                type="select"
                onChange={(e) => {
                  this.setCurrentProfile(e.target.value, e.target);
                }}
              >
                <option value="">{""}</option>
                {optionProfiles}
              </Form.Control>
            </Form.Group>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}
